import { render, staticRenderFns } from "./SchoolSelect.vue?vue&type=template&id=0df5db5c&scoped=true"
import script from "./SchoolSelect.vue?vue&type=script&lang=js"
export * from "./SchoolSelect.vue?vue&type=script&lang=js"
import style0 from "./SchoolSelect.vue?vue&type=style&index=0&id=0df5db5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df5db5c",
  null
  
)

export default component.exports